import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme, setTheme } from '../redux/features/theme/themeSlice';

export const useTheme = () => {
  const theme = useSelector((state) => state.theme.mode);
  const dispatch = useDispatch();

  const toggle = () => dispatch(toggleTheme());
  const set = (mode) => dispatch(setTheme(mode));

  return { theme, toggle, set };
};

